import "@/App.css";
import { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Portfolio } from "@/components/Portfolio";
import { ProyectosRecientes } from "@/components/ProyectosRecientes";
import { ProcesoEvolucion } from "@/components/ProcesoEvolucion";
import { ProcesoTrabajo } from "@/components/ProcesoTrabajo";
import { SobreMi } from "@/components/SobreMi";
import { DondeEstoy } from "@/components/DondeEstoy";
import { Contacto } from "@/components/Contacto";
import { Footer } from "@/components/Footer";
import { AdminPanel } from "@/components/AdminPanel";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Header />
      <Hero />
      <Portfolio />
      <ProyectosRecientes />
      <ProcesoEvolucion />
      <ProcesoTrabajo />
      <SobreMi />
      <DondeEstoy />
      <Contacto />
      <Footer />
    </div>
  );
};

class AppErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('No se pudo renderizar la página.', error);
  }

  render() {
    if (this.state.hasError) {
      return <main style={{ minHeight: '100vh', display: 'grid', placeContent: 'center', gap: '1rem', padding: '2rem', background: '#0b0b0a', color: '#f5f5f5', fontFamily: 'sans-serif', textAlign: 'center' }}><h1 style={{ fontSize: '1.5rem' }}>No se pudo cargar esta página</h1><p style={{ color: '#aaa' }}>Recarga para volver a intentarlo. Si continúa, comunícaselo al estudio.</p><button style={{ justifySelf: 'center', padding: '0.75rem 1rem', borderRadius: '0.5rem', background: '#c5a880', color: '#16130f', cursor: 'pointer' }} onClick={() => window.location.reload()}>Recargar</button></main>;
    }
    return this.props.children;
  }
}

function App() {
  return (
    <AppErrorBoundary>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/app" element={<AdminPanel />} />
              <Route path="/app/*" element={<AdminPanel />} />
            </Routes>
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </AppErrorBoundary>
  );
}

export default App;
